/*
const OldFooterText = `
* [The old site](https://archive.obstructures.org)
* [The old 0750 guitar page](https://0750.obstructures.org)
* [The old Model 34 bass page](https://model34.obstructures.org)
* [Instagram](https://instagram.com/obstructures)
`
*/

const FooterText = `
* [We're on Instagram](https://instagram.com/obstructures)
`

export default FooterText;